import React from 'react';
import { ForcedChoiceQuestion as QuestionType } from '../types/assessment';
import { ArrowLeft, Check } from 'lucide-react';
interface ForcedChoiceQuestionProps {
  question: QuestionType;
  onAnswer: (value: 0 | 1) => void;
  onBack?: () => void;
  canGoBack?: boolean;
  previousAnswer?: number;
}
export function ForcedChoiceQuestion({
  question,
  onAnswer,
  onBack,
  canGoBack = false,
  previousAnswer
}: ForcedChoiceQuestionProps) {
  const isASelected = previousAnswer === 1;
  const isBSelected = previousAnswer === 0;
  return <div className="max-w-2xl mx-auto px-4 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-35">
      {canGoBack && onBack && <button onClick={onBack} className="flex items-center text-[#6B7280] hover:text-[#E10600] transition-colors mb-8 group" data-id="element-36">
          <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-37" />
          <span className="text-sm font-bold uppercase tracking-widest" data-id="element-38">
            Back
          </span>
        </button>}

      <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-12 text-center leading-none tracking-wide" data-id="element-39">
        {question.text}
      </h2>

      <div className="grid gap-6 md:grid-cols-1" data-id="element-40">
        <button onClick={() => onAnswer(1)} className={`group relative flex items-center p-8 text-left rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#E10600] focus:ring-offset-2 focus:ring-offset-[#0B0F14] ${isASelected ? 'bg-[#1a1f2b] border-2 border-[#E10600] shadow-[0_0_20px_rgba(225,6,0,0.15)]' : 'bg-[#111318] border border-[#2a2f3b] hover:border-[#E10600] hover:bg-[#1a1f2b]'}`} data-id="element-41">
          <div className={`flex-shrink-0 w-10 h-10 rounded-md flex items-center justify-center font-bold font-display text-xl mr-6 transition-all duration-300 ${isASelected ? 'bg-[#E10600] text-white border border-[#E10600]' : 'bg-[#1a1f2b] text-[#6B7280] border border-[#2a2f3b] group-hover:bg-[#E10600] group-hover:text-white group-hover:border-[#E10600]'}`} data-id="element-42">
            A
          </div>
          <span className={`text-xl font-medium transition-colors ${isASelected ? 'text-white' : 'text-[#9ca3af] group-hover:text-white'}`} data-id="element-43">
            {question.optionA}
          </span>
          {isASelected && <Check className="ml-auto w-6 h-6 text-[#E10600] flex-shrink-0" data-id="element-44" />}
          {!isASelected && <div className="absolute inset-0 border border-[#E10600] opacity-0 group-hover:opacity-100 rounded-md transition-opacity duration-300 pointer-events-none shadow-[0_0_20px_rgba(225,6,0,0.1)]" data-id="element-45"></div>}
        </button>

        <button onClick={() => onAnswer(0)} className={`group relative flex items-center p-8 text-left rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#E10600] focus:ring-offset-2 focus:ring-offset-[#0B0F14] ${isBSelected ? 'bg-[#1a1f2b] border-2 border-[#E10600] shadow-[0_0_20px_rgba(225,6,0,0.15)]' : 'bg-[#111318] border border-[#2a2f3b] hover:border-[#E10600] hover:bg-[#1a1f2b]'}`} data-id="element-46">
          <div className={`flex-shrink-0 w-10 h-10 rounded-md flex items-center justify-center font-bold font-display text-xl mr-6 transition-all duration-300 ${isBSelected ? 'bg-[#E10600] text-white border border-[#E10600]' : 'bg-[#1a1f2b] text-[#6B7280] border border-[#2a2f3b] group-hover:bg-[#E10600] group-hover:text-white group-hover:border-[#E10600]'}`} data-id="element-47">
            B
          </div>
          <span className={`text-xl font-medium transition-colors ${isBSelected ? 'text-white' : 'text-[#9ca3af] group-hover:text-white'}`} data-id="element-48">
            {question.optionB}
          </span>
          {isBSelected && <Check className="ml-auto w-6 h-6 text-[#E10600] flex-shrink-0" data-id="element-49" />}
          {!isBSelected && <div className="absolute inset-0 border border-[#E10600] opacity-0 group-hover:opacity-100 rounded-md transition-opacity duration-300 pointer-events-none shadow-[0_0_20px_rgba(225,6,0,0.1)]" data-id="element-50"></div>}
        </button>
      </div>
    </div>;
}